/**
 * Número de protocolo exibido nos painéis — fonte única de verdade.
 *
 * Convivem DOIS esquemas, por decisão de produto (casos antigos nunca são renumerados):
 *
 *   1. Legado — sem `protocol_label`. O número é o `id` global: é o número que
 *      sempre circulou (#856, #520) e que continua valendo. `protocol_number` é
 *      ignorado de propósito — ver displayProtocol abaixo.
 *
 *   2. Atual — denúncias novas trazem `protocol_label` no formato `AAAA-NNN`
 *      (ex.: 2026-001), reiniciando em 1 a cada ano, por cliente. O prefixo do ano
 *      é o que impede a colisão com os números legados.
 *
 * Dual module shape: ESM `export const` para o build do CRA/webpack, com o guard
 * CommonJS no final para que o test runner do Node (require) valide a lógica real.
 */

/**
 * Número a exibir para uma denúncia, SEM o '#'.
 * Ordem: rótulo AAAA-NNN quando existir, senão o `id` global.
 *
 * `protocol_number` NÃO é fonte de exibição, de propósito. Aquela coluna foi
 * preenchida por um backfill que renumerou casos que já circulavam pelo id — no
 * MAUAD, o caso 520 passou a aparecer como 3. O número anterior de todo caso
 * existente é o id, e é ele que continua valendo. A coluna fica no banco, sem
 * leitor, para não precisar escrever em produção para desfazer o estrago.
 */
export const displayProtocol = (complaint) => {
  if (!complaint) return '';
  if (complaint.protocol_label) return String(complaint.protocol_label);
  return complaint.id != null ? String(complaint.id) : '';
};

/** Mesmo valor com o '#' na frente, para uso direto na UI. */
export const displayProtocolTag = (complaint) => {
  const value = displayProtocol(complaint);
  return value ? `#${value}` : '';
};

// CommonJS fallback so Node's test runner (require) can validate the real logic.
// CRA/webpack tolerates this trailing guard; the ESM exports above drive the build.
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { displayProtocol, displayProtocolTag };
}
